import { render, staticRenderFns } from "./MySvg.vue?vue&type=template&id=2349263e&"
import script from "./MySvg.vue?vue&type=script&lang=js&"
export * from "./MySvg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports